<template>
    <v-app>

        <menu-main
                :clipped="clipped"
                v-model="showMainMenu"
                v-if="hasMenu"
                @mini-version="(v) => mini = v"
                />
        <user-panel
            v-model="showUserPanel"
            />
    <!--navbar-->
        <navbar-top
            @toggleMenu="showMainMenu=!showMainMenu"
            @toggleUserPanel="showUserPanel=!showUserPanel"
            :clipped-left="clipped"
            :has-menu="hasMenu"

            >
            <slot slot=title name="title"><v-avatar size="40px" tile></v-avatar><small>{{trans('layout.title')}}</small></slot>
            <slot name="header"></slot>

        </navbar-top>

        <!-- Content -->
        <v-main>
            <div :style="'width:'+divWidth+' !important; float: right;'">
                <slot name="content">
                    <v-container>
                            <slot>Nothing here right now!</slot>
                    </v-container>
                </slot>
            </div>
        </v-main>
        <app-footer>
            <slot name="footer">
                <v-row
                    justify="center"
                    align="center"
                    v-html="trans('layout.footer')"
                    class="my-2"

                    ></v-row>
            </slot>
        </app-footer>
    </v-app>
</template>
<style lang="scss">
    .v-toolbar{
        .logo-main{
            height:45px;
        }
    }
</style>
<script>
import NavbarTop from './partials/NavbarTop'
import MenuMain from './partials/MenuMain'
import AppFooter from './partials/Footer'
import UserPanel from './partials/UserPanel'
import {mapGetters} from "vuex";

export default {
        name:'app-layout',
        props: {},
        data() {
            let navbar_clipped = localStorage.getItem('navbar_clipped');

            if(navbar_clipped === undefined) {
                navbar_clipped = false;
                localStorage.setItem('navbar_clipped', navbar_clipped);
            }

            let clipped = (navbar_clipped === 'true') ? true : false;

            return {
                clipped         ,
                showMainMenu    : null,
                showUserPanel   : false,
                mini: false
            }
        },
        mounted() {
        },
        computed: {
            ...mapGetters({
                menu:'mainMenu',
            }),
            hasMenu(){return this.menu && this.menu.length>0},
            divWidth() {
                return this.mini || !this.showMainMenu ? '100%' : 'calc(100% - 256px)';
            }
        },
        methods: {},

        components: {
            NavbarTop,
            MenuMain,
            AppFooter,
            UserPanel,
        },
        filters: {},
        watch: {
            'mini'() {
                this.divWidth;
            }
        }
    }
</script>
